import { render } from "./EmailTemplate.vue?vue&type=template&id=c529cd94&scoped=true"
import script from "./EmailTemplate.vue?vue&type=script&lang=js"
export * from "./EmailTemplate.vue?vue&type=script&lang=js"

import "./EmailTemplate.vue?vue&type=style&index=0&id=c529cd94&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c529cd94"],['__file',"src/components/EmailTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c529cd94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c529cd94', __exports__)) {
    api.reload('c529cd94', __exports__)
  }
  
  module.hot.accept("./EmailTemplate.vue?vue&type=template&id=c529cd94&scoped=true", () => {
    api.rerender('c529cd94', render)
  })

}


export default __exports__